export default __webpack_public_path__ + "static/media/us-um.16ec8b7c.svg";